import axios from 'axios';

function extendUnique (validator) {

    validator.extend('unique', {
        lazy: true,
        getMessage: field => 'Cet '+field+' est déjà enregistrée. Cette opération est limitée à une seule participation par foyer',
        async validate(value, [field, _id]) {

            try {
                const {data} = await axios.post('https://oxoform.fr/api/check/' + _id, { operationId : _id, [field] : value  } );

                if(data.status=='OK') {
                    return false;
                } else {
                    return true;
                }
            }
            catch(err) {
                return false;
            }
        }
        });
}

export default extendUnique;